import React from 'react'
import Banner from "./component/Banner"
export default function Disease() {
    return (
        <div className="disease">
            <Banner/>
            <div className="pre">
            <h1>Disease Prediction</h1>
            <h2>Upload image of infected crop for analysis below</h2>
            <input type="file" />
            <button>Predict</button></div>
        </div>
    )
}
